import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { GlobalStyle, AppDiv } from './AppStyles';
import AuthenticatedApp from './AuthenticatedApp';
import packageJson from '../../package.json';
import { msalErrorComponent, msalLoadingComponent } from '../components/MsalComponents'


function App() {

  return (
    <>
      <GlobalStyle />
      <AppDiv data-testid='appdiv-testid'>
        <MsalAuthenticationTemplate 
          interactionType={InteractionType.Redirect}
          errorComponent={msalErrorComponent}
          loadingComponent={msalLoadingComponent}
          >
        <AuthenticatedTemplate>
          <AuthenticatedApp 
          version={packageJson.version}
          />
        </AuthenticatedTemplate>
        </MsalAuthenticationTemplate>
        <UnauthenticatedTemplate>
          {process.env.REACT_APP_REDIRECT_URI}
          <h1>Nobody is signed in!</h1>
          </UnauthenticatedTemplate>
      </AppDiv >
    </>
  );
}

export default App;
